import { useTranslation } from "react-i18next";
import noPortalContent from "../../assets/images/noPortalContent.svg";
import css from "./index.module.css";

function NoPortalDataIllustration({ name }) {
  const { t } = useTranslation();
  return (
    <div className={css.noIllustrationsClass}>
      <div className="overflow-auto flex">
        <img src={noPortalContent} alt="no data to show" />
      </div>
      <span>
        {t("noDashboardCardData", {
          module_name: name,
        })}
      </span>
    </div>
  );
}

export default NoPortalDataIllustration;
